.root {
  display: flex;
  appearance: none;
  flex-direction: column;
  outline: none;
  gap: var(--theme--sizing--1x);
}